import { Component, Inject, Vue } from 'vue-property-decorator';
import RegistrationService from '@/apis/registration';
import AccountService from "@/components/account/account.service";
import { required, sameAs } from 'vuelidate/lib/validators';
// @ts-ignore
import md5 from 'crypto-js/md5';
import * as service from "@/methods/service";
import {fetchUserData} from "@/methods/service";
import store from "@/store";


const validations = {
	confirmPassword: { required, sameAsPassword: sameAs('password') },
	password: { required }
}
@Component({
	components: {},
	validations
})
export default class RecoveryPasswordComponent extends Vue {

	@Inject('accountService') private accountService!: () => AccountService;
	@Inject('registrationService') private registrationService!: () => RegistrationService;


	public password: string = '';
	public confirmPassword = '';
	public error = '';
	public clientId = '';
	public contactId: string | (string | null)[] = '';
	public login = '';
	public emailSuccessfullySent = false;

	async created() {
		if (this.$route.query.token && this.$route.query.contactid) {
			this.$store.commit('setOverlay', true)

			// await service.checkSecurityToken();

			const resetKey = this.$route.query.token;
			this.contactId = this.$route.query.contactid;

			try {
				await service.validateResetPasswordKey({
					resetKey,
					contactId: this.contactId,
				});

				const response = await service.fetchUserData(this.contactId);
				this.login = response.login
				this.clientId = response.clientId
				this.$store.commit('setOverlay', false)
			} catch (e) {
				this.$store.commit('setOverlay', false)
				if(e.message === 'Contact reset key invalid.') {
					this.error = e.message
					setTimeout('this.$router.push(\'/\');', 2000)
				} else {
					this.error = e.message
				}
			}

		}
	}

	public async submit() {
		try {
			this.$store.commit('setOverlay', true)
			const requestData = {
				securityToken: store.getters.token,
				clientId: this.clientId,
				contactId: this.contactId,
				login: this.login,
				password: this.password
			};
			await service.setPassword(requestData);
			this.$store.commit('setOverlay', false)
			this.error = 'Password changed successfully';
			setTimeout(() => {this.$router.push('/')}, 1000)

		} catch (e) {
			this.$store.commit('setOverlay', false)
			this.error = e.message;
		}
	}
}
